import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import { NumberInput } from 'ui-components/components/number-input';

const EditableNumberCell = ({ value, min, max, onChange }) => {
  const [internalValue, setInternalValue] = useState(value);

  const onArrowButtonPress = useCallback(
    (newValue) => {
      setInternalValue(newValue);
      onChange(newValue);
    },
    [onChange],
  );

  const onBlur = useCallback(() => {
    onChange(internalValue);
  }, [internalValue, onChange]);

  return (
    <NumberInput
      max={max}
      min={min}
      onArrowButtonPress={onArrowButtonPress}
      onBlur={onBlur}
      onChange={setInternalValue}
      value={internalValue}
    />
  );
};

export default EditableNumberCell;

EditableNumberCell.propTypes = {
  value: PropTypes.number.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};
